export default "__VITE_ASSET__C5rSVZJ5__"